"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.655 11.053a.7.7 0 0 1 .002.99l-3.919 3.933a.7.7 0 0 1-.992 0l-2.401-2.41a.7.7 0 0 1 .991-.989l1.906 1.913 3.423-3.435a.7.7 0 0 1 .99-.002",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.993 8.426c.6-2.543 3.202-4.35 6.008-4.35 3.1 0 5.426 1.995 5.775 4.329 1.03.237 1.994.892 2.728 1.748.884 1.031 1.496 2.424 1.496 3.93 0 3.222-2.441 5.84-5.754 5.84h-9.04C4.249 19.923 2 17.22 2 14.083c0-2.699 1.657-5.035 3.993-5.657m6.008-2.95c-2.432 0-4.459 1.662-4.71 3.626a.7.7 0 0 1-.586.603c-1.802.28-3.305 2.063-3.305 4.378 0 2.541 1.788 4.44 3.807 4.44h9.04c2.499 0 4.353-1.95 4.353-4.44 0-1.128-.462-2.206-1.16-3.019-.704-.821-1.585-1.303-2.363-1.352a.7.7 0 0 1-.656-.699c0-1.656-1.66-3.536-4.42-3.536",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=StatusUpdatedIcon24.js.map